import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import HandOffLink from '../../../utils/urls/HandOffLink';
import colors from '../../../styling/colors';

const buttonLinkStyles = ({ color }) => css`
  position: relative;
  color: ${colors(color)};
  cursor: pointer;
  display: inline-block;
  font-size: 0.75rem;
  font-weight: bold;
  letter-spacing: 2px;
  line-height: 1rem;
  text-transform: uppercase;

  ::after {
    background-color: ${colors(color)};
    bottom: -5px;
    content: '';
    display: block;
    height: 1px;
    left: 1px;
    position: absolute;
    width: calc(100% - 4px);
  }
`;

const ButtonLink = styled(HandOffLink)`
  ${buttonLinkStyles};
`;

ButtonLink.propTypes = {
  color: PropTypes.oneOf(['lapel', 'gatsby']),
};

ButtonLink.defaultProps = {
  color: 'lapel',
};

export const ButtonLinkText = styled.span`
  ${buttonLinkStyles};
`;

export const ExternalButtonLink = styled(HandOffLink)`
  ${buttonLinkStyles};
`;

export default ButtonLink;
